import { get, post, put } from "aws-amplify/api";
import config from "config";
import 'containers/common/Detail.css';
import PropertyArticleList from "containers/property/PropertyArticleList";
import PropertyArticleModal from "containers/property/PropertyArticleModal";
import { _s3GetURL, s3Upload } from "lib/awsLib";
import Moment from "moment";
import React, { Component } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Alert, Button, Card, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { PacmanLoader } from 'react-spinners';

const source = null;

class ArticleDetailClass extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.file = null;

        this.state = {
            isLoading: null,
            isDeleting: null,
            article: null,    
            showAlert: false,
            errorMessage: "",
            modified: false,
            propertyidlist: [],
            showPropertyArticleDialog: false,
            propertyArticles: [],
            articleCategories: [],
            fileTypes: [],
            propertyFilter: null,
            selectedArticleCategory: null,
            selectedFileType: null,
            url: "",
            property_key: this.props.match.params.propertyid,
            property_id: null,
            article_id: "",
            article_date: null,
            source: "",
            brief_description : "",
            article_category_code: null,
            article_category: "", 
            file_name: "",
            file_type : null,
            file_ext: "",
            created_date: null,
            created_by: "",
            last_edited_date: null,
            last_edited_by: ""

        };



       

    }

    

    //componentWillUnmount() {
    //    source.cancel();
    //    this.setState({ proposal: [] });
     
    //}

  
    async componentDidMount() {
        
        await this.getFileTypes();
        try {
            this.setState({ isLoading: true });   
            if (this.props.location.state){
                if (this.props.location.state.propertyidlist){
                    this.setState({propertyidlist: this.props.location.state.propertyidlist});
                }
            }

            if (this.props.match.params.id === "new") {
                this.setState(state => ({ property_id: this.props.location.search.replace("?propertyid=", ""), created_by: this.props.user, article_date: new Date() }));
                

                await this.syncroniseState();
                document.title = "New article for " + this.state.property_key;

            }
            else {
                
                const article = await this.retrieveArticle();
                if (!article || !article.article_id) {
                    console.error("Article is null or article_id is missing", article);
                    this.setState({ errorMessage: "Failed to load article data", showAlert: true });
                    this.setState({ isLoading: false });
                    return;
                }
                const propertyFilter = { articleid: article.article_id };

                // Load properties without throwing error to outer catch
                try {
                    await this.getProperties(propertyFilter);
                }
                catch(error){
                    console.error("Error loading properties:", error);
                    // Don't rethrow - let component render even if properties fail to load
                }
                
                let file_ext = "";
                for(var i =0;i< this.state.fileTypes.length;i++){
                    if (this.state.fileTypes[i].value === this.state.file_type)
                    {
                        file_ext = this.state.fileTypes[i].label;
                    }
                    
                }

                const file = this.state.file_name+"."+this.state.file_ext  ;
                const url = await _s3GetURL(file);
                this.setState({url});

                


                document.title = this.state.file_name ;
           
            }
            
            //Get lookups
            this.setState({ selectedArticleCategory: { value: this.state.article_category_code, label: this.state.article_category } });
            this.setState({ selectedFileType: { value: this.state.file_type, label: this.state.file_ext } });

            
            await this.getArticleCategories();

            
            this.setState({ isLoading: false });   
        } catch (e) {
            console.error("ArticleDetail componentDidMount error:", e);
            alert("Error: " + (e.message || e));
        }
    }

    async syncroniseState() {
        const article = {
            article_id: this.state.article_id,
            article_date: this.state.article_date,
            source: this.state.source,
            brief_description: this.state.brief_description,
            article_category_code: this.state.article_category_code,
            article_category: this.state.article_category,
            file_name: this.state.file_name,
            file_type: this.state.file_type,
            file_ext: this.state.file_ext,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by
        };

        this.setState({ article });
    }

    async retrieveArticle() {
        const article = await this.getArticle();

        const {
            article_id,
            article_date,
            source,
            brief_description,
            article_category_code,
            article_category,
            file_name,
            file_type,
            file_ext,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = article;

        this.setState({
            article,
            article_id,
            article_date,
            source,
            brief_description,
            article_category_code,
            article_category,
            file_name,
            file_type,
            file_ext,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });
        
        return article;
    }


    //Call API
    


    async getArticle() {
        try {
            const { body } = await get({
                apiName: "colin",
                path: `/articles/${this.props.match.params.id}`
            }).response;
            const result = await body.json();
            return result;
        }
        catch(error){
            console.error("Error getting article:", error);
            throw error;
        }
        
    }

    async saveArticle(article) {
        
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.article_id === "") {
            this.setState({ created_by: this.props.user });
            try {
                const { body } = await post({
                    apiName: "colin",
                    path: `/articles/new`,
                    options: { body: article }
                }).response;
                return await body.json();
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            }
        }
        
        try {
            const { body } = await put({
                apiName: "colin",
                path: `/articles/${this.state.article_id}`,
                options: { body: article }
            }).response;
            return await body.json();
        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        }
    }

    



    async getProperties(filter) {
        try {
            const { body } = await get({
                apiName: "colin",
                path: "/propertyarticles",
                options: { queryParams: filter }
            }).response;
            const propertyArticles = await body.json();
            if (propertyArticles) {
                this.setState({ propertyArticles: Array.isArray(propertyArticles) ? propertyArticles : [] });
            }
        }
        catch(error){
            console.error("Error getting articles:", error);
        }
    }
   
    async getArticleCategories() {
        try {
            const { body } = await get({
                apiName: "colin",
                path: "/articlecategories/dropdown"
            }).response;
            const articleCategories = await body.json();
            if (articleCategories) {
                this.setState({ articleCategories });
            }
        }
        catch(error){
            console.log("Error getting article categories", error);
        }
    }

    async getFileTypes() {
        try {
            console.log("Getting file types");
            const { body } = await get({
                apiName: "colin",
                path: "/filetypes"
            }).response;
            const fileTypes = await body.json();
            if (fileTypes) {
                this.setState({ fileTypes });
            }
        }
        catch(error){
            console.log("Error getting file types", error);
        }
    }

  

    



    

    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh nabers");

        const nabers = await this.getNabers(this.state.naberFilter);
        this.setState({ nabers });
    }

    
    validateRelatedRecord(record, set) {
        //property
        if (set === "article") {

            // secondly check that UnitSort has been specified if required

            if (!this.state.file_name) {
                return [false, "File name cannot be empty"];
            }

            if (this.state.file_name.length>255) {
                return [false, "File name cannot be longer than 255 characters"];
            }

            if (!this.state.source) {
                return [false, "Source cannot be empty"];
            }
            else {
                if (this.state.source.length > 10) {
                    return [false, "Source cannot be longer than 10 chars"];
                }
            }

            // if (!config.ATTACHMENT_TYPE.includes(this.state.file_ext)) {
            //     return [false, "Files must be of type JPEG, TIF, PDF, Doc, Docx, RTF, HTML"];
            // }
            if (this.file != null){
                if (this.file.size > config.MAX_ATTACHMENT_SIZE) {
                    return [false, "Files must be less than 50mb in size"];
                }
            }


        }

        if (set === "propertyArticles") {

            // secondly check that UnitSort has been specified if required

            if (!record.property_key) {
                return [false, "Enter a Cityscope reference."];
            }


        }

        return [true,];
    }

    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
    }

    async saveRecord(record, endpoint, id) {

        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                const { body } = await post({
                    apiName: "colin",
                    path: `/${endpoint.toLowerCase()}/new`,
                    options: { body: record }
                }).response;
                return await body.json();
            }
        }
        //If not a new record and updating an existing, perform a put
        const { body } = await put({
            apiName: "colin",
            path: `/${endpoint.toLowerCase()}/${record[id]}`,
            options: { body: record }
        }).response;
        return await body.json();
    }
    

    
    handleArticleCategoryChange = (selectedArticleCategory) => {
        this.setState({ selectedArticleCategory 
                        ,article_category_code: selectedArticleCategory.value 
                        , modified: true },this.handleBlur);
    }


    handleFileTypeChange = (selectedFileType) => {

        this.setState({ selectedFileType
                        ,file_type: selectedFileType.value 
                        , modified: true },this.handleBlur);
    }



    

    handleChange = event => {
        if (event.target.id==="source" && event.target.value.length>10){
            return
        } 
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

    handleFileChange = async event => {
        this.file = event.target.files[0];
        this.setState({ modified: true });
        let file_name = this.file.name.substring(0, this.file.name.indexOf("."));
        let file_ext = this.file.name.replace(file_name + '.', '').toLowerCase();
        let file_type = 9;
        for (var i = 0; i < this.state.fileTypes.length; i++) {
            
             if (this.state.fileTypes[i].label.toLowerCase() === file_ext) {
                 file_type = this.state.fileTypes[i].value;
             }
        }
        // console.log(file_type);
        this.setState({ file_type 
                        , file_name
                        ,file_ext }, this.handleBlur);

        
    }



    handleDateChange(date, name) {
       var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur);    

    }


    
    async addPropertyRelation(articleId) {
        let data = [...this.state.propertyArticles];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_id: this.state.property_id,
            property_key: this.state.property_key,
            article_id: articleId,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.updateTableState(data, "propertyArticles");
        const result = await this.saveRecord(data[0], "propertyArticles", "article_property_link_id");
        console.log(result);
        if (result.result) {
            data[0].article_property_link_id = result.id;
            data[0].new_record = false;
            this.updateTableState(data, "propertyArticles");
        }
        else {
            this.setState({ errorMessage: result.error_message });
            this.setState({ showAlert: true });
        }

        return;
    }

    handleBlur = async event => {
        
        if (this.state.modified === true) {
            this.setState({ showAlert: false });

            
            await this.syncroniseState();
            

            const validation = this.validateRelatedRecord(this.state.article, "article");
            console.log(validation)
            if (validation[0] === true) {
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                   

                    const result = await this.saveArticle(this.state.article);
                    this.setState({ isLoading: false });
                    if (result.result === false) {
                        alert(result.error_message);
                        this.setState({url: ""});
                    }
                    else {
                        //Upload after the database has checked the file does not exist
                        const folder = "public/article";
                        const attachment = this.file
                            ? await s3Upload(this.file, folder)
                            : null;
                        console.log("Attachment name-"+attachment);
                        let url=null;
                        if(attachment){
                            url = await _s3GetURL(attachment.replace('public/article/',""), 'public/article');
                        }
                        else{
                            const file = this.state.file_name+"."+this.state.file_ext  ;
                            url = await _s3GetURL(file.replace('public/article/',""), 'public/article');
                            }
                        this.setState({url});
                        
                        
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ article_id: result.id }));
                            console.log("Adding relation");
                            //Create relation to property
                            await this.addPropertyRelation(result.id);
                            this.props.history.push("/articles/" + result.id);
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }


    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {
            if (!this.state.registered) {
                const confirmed = window.confirm(
                    "Are you sure you want to delete this article?"
                );

                if (!confirmed) {
                    return;
                }
                else {
                    this.setState({ archived_date: new Date() }, () =>
                        this.syncroniseState().then(async () => {
                            const result = await this.saveArticle(this.state.article);
                            if (result.result === false) {
                                alert(result.error_message);
                            }
                            else {

                                this.props.history.push("/");
                            }
                        }
                        )
                    );

                }

            }
            else {
                window.alert("Record cannot be deleted");
            }
        }
    }


    togglePropertyArticleModal = async () => {
        this.setState(state => ({
            showPropertyArticleDialog: !this.state.showPropertyArticleDialog
        }));

    }

    deleteFile = () =>{
        this.setState({file_name: "", file_ext: "", modified: true},this.handleBlur);
    }
    

    render() {
        return (
            <div className="Article">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
                {this.state.showPropertyArticleDialog &&
                    <PropertyArticleModal
                    show={this.state.showPropertyArticleDialog}
                    onClose={this.togglePropertyArticleModal}
                    isAuthenticated={this.props.isAuthenticated}
                    togglePropertyArticleModal={this.togglePropertyArticleModal}
                    user={this.props.user}
                    data={this.state.propertyArticles}
                    updateTableState={this.updateTableState}
                    saveRecord={this.saveRecord}
                    deleteRecord={this.deleteRecord}
                    validateRelatedRecord={this.validateRelatedRecord}
                    articleid={this.state.article_id}
                    />
                }
               
                {this.state.article && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="ArticleForm">
                   
                    <Form onSubmit={this.handleSubmit} >
                        <Row><Col sm={4} md={4} lg={4}>

                        </Col>
                            <Col md={{ span: 1, offset: 7 }} >
                                <Button
                                    variant="danger"
                                    onClick={this.handleDelete}

                                >Delete</Button>
                            </Col>
                        </Row>
                    <Row  id="detail">
                            <Col>
                            <Modal show={this.state.showAlert  && this.state.article_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                            {this.state.showAlert && !this.state.article_id &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                                <Tabs defaultActiveKey={0} id="tabset">
                                    <Tab eventKey={0} title="Article Detail">
                        <Card >
                                <Card.Header >
                                
                                        Article Details - {this.state.property_key} - 
                            
                            </Card.Header>

                                
                                    <Card.Body>
                                        

                                    <Row>
                                           
                                    <Col sm={12} md={6} lg={3}>

<Card >

    <Card.Body>

        <Form.Group as={Row} controlId="file_name" >
            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}></Form.Label>
            <Col>
                <Form.Control
                    onChange={this.handleFileChange}
                    as="input"
                    type="file"
                    onBlur={this.handleBlur}

                />
            </Col>

        </Form.Group>
        <Form.Group as={Row} controlId="file_name" >
            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Name</Form.Label>
            <Col>
                <Form.Control

                    value={this.state.file_name}
                    as="input"
                    type="text"
                    onChange={this.handleChange}

                />
            </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="file_ext" >
            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>File Type</Form.Label>
            <Col>
                <Form.Control
                    value={this.state.file_ext}                                                                  
                    as="input"
                    type="text"                                                                    
                    onChange={this.handleChange}
                />
            </Col>

        </Form.Group>
        {this.state.file_name &&
            <Row>
            <Col sm={6} md={6} lg={4}> </Col>
            <Col> 
                {this.state.url &&
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                href={this.state.url}
                                >
                                    {this.state.file_name + "." + this.state.file_ext}
                                </a>
                                
                }
            </Col>
            <Col>{this.state.url &&<Button size="sm" onClick={this.deleteFile} variant="danger">Delete File</Button>}</Col>
            </Row>


        }


    </Card.Body>
</Card>



</Col>
                                            <Col sm={12} md={6} lg={3}>

                                                <Card >
                                                    
                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="article_id" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>ID</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.article_id}
                                                                    as="input"
                                                                    type="text"
                                                                    readOnly
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="article_date" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Article Date</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={this.state.article_date? new Date(this.state.article_date): null}
                                                                    onChange={e => this.handleDateChange(e, "article_date")}
                                                                    onBlur={this.handleBlur}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    
                                                                    className="form-control"
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="source" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Source</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.source}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="brief_description" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Description</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.brief_description}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="article_category_code" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Article Category</Form.Label>
                                                            <Col>
                                                                <Select
                                                                    value={this.state.selectedArticleCategory}
                                                                    onChange={this.handleArticleCategoryChange}
                                                                    options={this.state.articleCategories}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        
                                                        
                                                    </Card.Body>
                                                    </Card>
                                                </Col>



                                            


                                            <Col sm={12} md={6} lg={3}>

                                                <Card id="col3head1"  >
                                                    <Card.Header> Properties </Card.Header>

                                                    <Card.Body>

                                                        <Button onClick={this.togglePropertyArticleModal} size="sm" variant="secondary">Edit</Button>
                                                        <PropertyArticleList
                                                            isAuthenticated={this.props.isAuthenticated}
                                                            controlType="list"
                                                            data={this.state.propertyArticles}
                                                            updateTableState={this.updateTableState}
                                                            saveRecord={this.saveRecord}
                                                            deleteRecord={this.deleteRecord}
                                                            propertyid={this.state.property_id}
                                                            propertykey={this.state.property_key}
                                                            proposalid={this.state.article_id}
                                                            propertyidlist={this.state.propertyidlist}
                                                        />

                                                    </Card.Body>
                                                </Card>



                                            </Col>
                                            

                                            
                                         


                                    </Row>






                                </Card.Body>
                            
                        </Card >
                        </Tab>
                    

                           


                            
                                    
                              <Tab eventKey={1} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                            <Card.Body>
                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date && Moment(this.state.created_date).isValid()
                                                                ? Moment(this.state.created_date).local().format("DD-MM-YYYY")
                                                                : ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date && Moment(this.state.last_edited_date).isValid()
                                                                ? Moment(this.state.last_edited_date).local().format("DD-MM-YYYY")
                                                                : ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                            </Card.Body>
                                </Card>

                            </Tab>

                        
                    </Tabs>

                        </Col>

                    </Row>
                   

                    
                    
                        
                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}

export default function ArticleDetail(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const match = { params, isExact: true, path: location.pathname, url: location.pathname };
    const history = { push: (path) => navigate(path) };
    return <ArticleDetailClass {...props} match={match} location={location} history={history} />;
}